import pluralize from 'pluralize'

import type { CellContext } from '@/components/ui/table/types'
import { cn } from '@/utils'

interface CounterCellProps {
  cell: CellContext<any, number>
  suffix?: string
  className?: string
}

export const CounterCell = ({ cell, suffix, className }: CounterCellProps) => {
  const count = cell.getValue() ?? 0
  const formattedSuffix = suffix
    ? count === 1
      ? suffix
      : pluralize(suffix)
    : null

  return (
    <div className={cn(className)}>
      {count}
      {formattedSuffix && ` ${formattedSuffix}`}
    </div>
  )
}
